import { apiClient } from '@/lib/api-client';
import type { IcdRef, Patient, PatientDetail } from '@/types/api';

export type PatientInput = {
  firstName: string;
  lastName: string;
  birthDate?: string | null;
  phone?: string | null;
  notes?: string | null;
  /** ICD-10 codes. */
  diagnoses?: string[];
  allergies?: string[];
};

export const patientsApi = {
  /** Most recently visited or created first. */
  async list(q: string, limit = 50) {
    const { data } = await apiClient.get<Patient[]>('/patients', {
      params: { q: q || undefined, limit },
    });
    return data;
  },
  async get(id: string) {
    const { data } = await apiClient.get<PatientDetail>(`/patients/${id}`);
    return data;
  },
  async create(input: PatientInput) {
    const { data } = await apiClient.post<Patient>('/patients', input);
    return data;
  },
  async update(id: string, input: Partial<PatientInput>) {
    const { data } = await apiClient.patch<Patient>(`/patients/${id}`, input);
    return data;
  },
  /** ICD-10 by code ("K02.1") or name; the dental chapter first. */
  async searchIcd(q: string) {
    const { data } = await apiClient.get<IcdRef[]>('/icd', { params: { q, limit: 30 } });
    return data;
  },
  /** The codes this clinic uses most. */
  async frequentIcd() {
    const { data } = await apiClient.get<IcdRef[]>('/icd/frequent');
    return data;
  },
};
